import React, { useEffect, useState } from 'react';
import { Sub } from '../../types/subscription/sub';
import { ESubscription } from '../../types/user/user';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import styles from './css/SelectPeriod.module.css';
import Dropdown from '../Elements/Dropdown';

export interface SelectPeriodProps {
  currIndex: number
	subs: Sub[];
  accessType: ESubscription;
  onSubChange: (sub: Sub) => void;
  onSubscribe:(sub: Sub) => void;
  selectedSub?: Sub | null;
  setActive: (currIndex: number) => void;
}

const DropdownMenu: React.FC<SelectPeriodProps> = ({ currIndex, subs, accessType, onSubChange, selectedSub: parentSelectedSub, onSubscribe, setActive }) => {
  const {
      current: currentLang,
      lang: { Value: lang },
    } = useTypedSelector(x => x.lang)
  const user = useTypedSelector(x => x.user.user)

  const filteredSubs = subs
    .filter(sub => sub.sub === accessType)
    .sort((a, b) => a.period - b.period);

  const defaultSub = filteredSubs.find(sub => sub.period === 30) || filteredSubs[0];
 
  useEffect(() => {
    if (!parentSelectedSub && defaultSub) {
      onSubChange(defaultSub);
    }
  }, [defaultSub, parentSelectedSub, onSubChange]);

  const handleSelect = (sub: Sub) => {
    onSubChange(sub);

    setActive(subs.findIndex(item =>
      item.sub === sub.sub &&
      item.period === sub.period &&
      item.price === sub.price
  ));
  };

  const getPrice = (sub: Sub) => sub.period >= 30 ? sub.price - sub.discount : sub.price
  
  const getDiscount = (sub: Sub) => Math.ceil(sub.discount)
  const getKeyWord = (sub: Sub): string =>  {
    const count = sub.discount;
    if (currentLang === 0) {
      const lastTwo = count % 100;
      const lastOne = count % 10;
      
      if (lastTwo >= 11 && lastTwo <= 19) {
        return 'ключей';
      }
      
      switch (lastOne) {
        case 1:
          return 'ключ';
        case 2:
        case 3:
        case 4:
          return 'ключа';
        default:
          return 'ключей';
      }
    } else {
      return count === 1 ? 'key' : 'keys';
    }
  }

  return (
		<Dropdown>
			{
				<span
        className={`btn-hov ${styles.buyBtn} ${styles.title} title`}
        >
        {user.access === accessType
          ? ({ 0: 'Продлить' }[currentLang] || 'Renew')
          : ({ 0: 'Подписаться' }[currentLang] || 'Subscribe')}
      </span>
			}
			<div className={`menu ${styles.menu}`}>
				{filteredSubs.map((sub, i) => {
					if(sub.sub !== accessType) return 
					return (
						<div className={`${styles.menuItem} menu-item`} onClick={() => handleSelect(sub)} key={i}>
							{sub.period} {{ 0: 'дней' }[currentLang] || 'days'} -
              {
                  (sub.price - sub.discount) <= 0
                      ? <span className={styles.subPrice}>{{ 0: ' Бесплатно', 1: ' Free' }[currentLang] || ' Free'}</span>
                      : ` ${getPrice(sub)} x`
              }
              { (sub.price - sub.discount) > 0 && (
                  <img src="Resources/key_mini.png" alt="key" className="ml-1" />
              )}
              
              {sub.discount > 0 ? ` (-${getDiscount(sub)} ${getKeyWord(sub)})` : ``}
						</div>
					)
				})}
			</div>
		</Dropdown>
  );
};

export default DropdownMenu;